import React from "react";
import "./LoadingSpinner.css";

const loadingSpinner = () => {
    return (<div className="loading-spinner">
    </div>);
}

export default loadingSpinner;